<template>
    <!-- Rhinoplasty Modal -->
    <div
        class="modal fade"
        :id="patient.id"
        tabindex="-1"
        :aria-labelledby="patient.id"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body" id="box">
                    <!-- Masthead -->
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="modal-title" :id="patient.id">
                                {{ section.type }}
                            </h3>
                        </div>
                    </div>
                    <!-- Masthead END -->

                    <div class="row mb-4">
                        <div
                            class="col-12 col-lg-6 pDescript align-items-center"
                        >
                            <div>
                                <p>
                                    {{ patient.description }}
                                </p>
                                <a
                                    href="../get-in-touch"
                                    class="btn btn-gold btn-small w-100 mt-4"
                                    >Schedule appointment
                                    <i
                                        class="fa-regular fa-angles-right ms-3"
                                    ></i
                                ></a>
                            </div>
                        </div>

                        <div
                            id="beforeAfterSlider"
                            class="col-12 col-lg-6 d-flex justify-content-center justify-content-md-end"
                        >
                            <div
                                class="swiper swiper-container swiper-beforeafter"
                            >
                                <div class="swiper-wrapper">
                                    <div
                                        class="swiper-slide"
                                        v-for="modalImage in patient.modalImages"
                                        :key="modalImage.imageWeb"
                                    >
                                        <div class="swiper-img">
                                            <a
                                                :data-fslightbox="patient.id"
                                                :href="modalImage.imageWeb"
                                                ><picture>
                                                    <source
                                                        type="image/webp"
                                                        :srcset="
                                                            modalImage.imageWeb
                                                        "
                                                    />
                                                    <img
                                                        loading="lazy"
                                                        :src="
                                                            modalImage.imageWeb
                                                        "
                                                        :alt="patient.alt"
                                                        class="img-fluid"
                                                    /> </picture
                                            ></a>
                                        </div>
                                    </div>
                                </div>

                                <CarouselControls />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Rhinoplasty Modal END -->
</template>

<script>
import CarouselControls from "../partials/carousel-controls-partials.vue";

export default {
    props: ["patient", "section"],
    components: {
        CarouselControls,
    },
    setup() {
        return {};
    },
};
</script>
